<script>
export default {
    name: 'VcepProtocolLink'
}
</script>
<template>
  <a
    href="https://www.clinicalgenome.org/docs/clingen-variant-curation-expert-panel-vcep-protocol/"
    target="vcep-protocol"
  >
    <slot>VCEP Protocol</slot>
  </a>
</template>
